// extracted by mini-css-extract-plugin
export var fullWidthButton = "_ic-0";